// Albeit the attribute keys can be anything, we
// take a thorough approach on possible keys. These
// attributes can be used for the cart, line items, orders.
export enum SHOPIFY_ATTRIBUTES {
  LIST = '_list',
  USER_ID = '_userId',
  ALGOLIA_QUERY_ID = '_algoliaQueryId',
  GIFT_CARD_SENDERS_NAME = 'senderName',
  GIFT_CARD_RECIPIENTS_NAME = 'recipientName',
  GIFT_CARD_RECIPIENTS_EMAIL = 'recipientEmail',
  GIFT_CARD_DATE_OF_BIRTH = 'date',
  GIFT_CARD_MESSAGE = 'message',
}
